import React from 'react';
import StoryEditorView from "./story_editor_view";
import {Colors, Routes} from "../../components/constants";
import {backgrounds} from "components/tools_pane/tools_items";
import uuid from 'uuid/v4'
import {dbPages, dbStories, auth, getOpts} from "components/firebase";
import {arrayMove} from "react-sortable-hoc";

export const TITLE_LAYOUT_A = 0;
export const TITLE_LAYOUT_B = 1;
export const TITLE_LAYOUT_C = 2;

class StoryEditor extends React.Component {
    readOnly = true;

    constructor(props) {
        super(props);
        if (!!props.setTitleLayout) {
            props.setTitleLayout((layout) => this.setTitleLayout(layout));
        }
        this.pagesSubscribed = false;
        this.subscriptions = [];
        this.pages = {};
        if (window.location.hash.length === 0) props.history.replace(Routes.myStories);
        this.state = {
            pagesOpen: false,
            toolsOpen: false,
            isDragging: false,
            uuidKey: uuid(),
            loading: true,
            pages: null,
            textToolsOpen: false
        };
        this.preview = !!props.preview;
        this.storyId = this._parseHashStoryId(window.location.hash);
        this.story = dbStories.doc(this.storyId);
        if (this.storyId.length === 0) {
            this.props.history.replace(Routes.myStories);
            return;
        }

        this._loadData();
    }

    setTitleLayout(layout) {
        this.story.update({
            titleLayout: layout
        });
        this.setState({titleLayout: layout});
    }

    _parseHashStoryId(hash) {
        hash = hash.substring(1);
        if (hash.includes('&')) {
            return hash.split('&')[0]
        } else {
            return hash;
        }
    }

    _parseHashPage(hash) {
        if (hash.includes('&')) {
            return parseInt(hash.split('&')[1]);
        } else {
            return 0;
        }
    }

    async _loadData() {
        try {
            this.storyDoc = await this.story.get();
        } catch (e) {
            // error.code === 'permission-denied'
            this.props.history.replace(Routes.myStories);
            return;
        }
        this.readOnly = this.preview || StoryEditor.readOnly(this.storyDoc.data());
        let unsubscribe = this.story.onSnapshot(async doc => {
            if (!doc.exists) this.props.history.replace(Routes.myStories);
            let nPages = (!!this.storyDoc && !!this.storyDoc.data().pages) ? this.storyDoc.data().pages.length : null;
            this.storyDoc = doc;
            let story = doc.data();
            if (!story.pages || story.pages.length === 0) {
                this.addPage();
                return;
            }

            if (nPages !== story.pages.length) {
                this.applyPages();
            }

            if (this.state.page === undefined) {
                this.setActivePage(this._parseHashPage(window.location.hash));
            }
        }, (error => {
            // error.code === 'permission-denied'
            this.props.history.replace(Routes.myStories);
        }));
        this.subscriptions.push(unsubscribe);

        unsubscribe = dbPages
            .where('owner', '==', this.storyDoc.data().owner)
            .where('story', '==', this.story)
            .onSnapshot(async snapshot => {
                snapshot.docChanges().forEach(doc => {
                    if (doc.type === "removed") {
                        delete this.pages[doc.doc.id];
                    } else {
                        if (doc.type === 'added' && (this.pagesSubscribed || (!!this.storyDoc && !this.storyDoc.data().pages))) {
                            let sdoc = this.storyDoc.data();
                            let pages = !!sdoc.pages ? sdoc.pages : [];
                            pages.push(dbPages.doc(doc.doc.id));
                            this.story.update({
                                pages: pages
                            });
                        }
                        this.pages[doc.doc.id] = doc.doc.data();
                    }
                });
                this.applyPages();
                if (this.state.page === undefined) {
                    this.setActivePage(0);
                }
                this.pagesSubscribed = true;
            });
        this.subscriptions.push(unsubscribe);
    }

    applyPages() {
        if (!this.storyDoc || !this.storyDoc.data().pages) return;
        let pages = [];
        let story = this.storyDoc.data();
        for (let i = 0; i < story.pages.length; i++) {
            let page = this.pages[story.pages[i].id];
            if (!page) {
                console.log("ERROR! page is undefined");
                console.log(story.pages[i].id);
                console.log(this.pages);

                continue;
            }
            pages.push(page);
        }
        console.log('apply pages' + pages);
        // active page
        this.setState({
            pages: pages
        });
    }

    _getCurrentBg() {
        if (!this.state.page) return;
        let page = this.state.page;
        // load bg from active page
        let pdoc = this.pages[page.id];
        if (!pdoc) {
            console.log("ERROR page undefined");
        }
        if (!pdoc) return null;
        return backgrounds[pdoc.background];
    }

    editTitle() {
        this.props.history.push(Routes.storyEditorTitleWHash(this.storyId, this.state.pageN));
    }

    async addPage() {
        if (!this.storyDoc) return;
        await dbPages.add({
            owner: auth.currentUser.uid,
            story: this.story
        });
        this.setActivePage(this.storyDoc.data().pages.length - 1);
    }

    finish() {
        if (this.readOnly) {
            this.props.history.replace(Routes.myStories);
            return;
        }
        this.props.history.push(Routes.storyEditorLayoutWHash(this.storyId, 0));
    }

    async setActivePage(i) {
        if (!this.storyDoc || !this.storyDoc.data().pages) return;
        let story = this.storyDoc.data();
        let pageN = i;
        if (story.pages.length <= pageN) {
            if (this.readOnly) {
                return;
            }
            await this.addPage();
            this.setActivePage(i);
            return;
        } else if (pageN < 0) {
            pageN = 0;
            return;
        }
        this.setState({
            page: story.pages[pageN],
            pageN: pageN
        });
        window.location.replace('#' + this.storyId + '&' + pageN);
    }

    async reorderPages({oldIndex, newIndex}) {
        if (oldIndex === newIndex) return;
        oldIndex++;
        newIndex++;
        let doc = this.storyDoc.data();
        doc.pages = arrayMove(doc.pages, oldIndex, newIndex);
        this.story.update({
            pages: doc.pages
        });
        this.setState({
            pageN: oldIndex === this.state.pageN ? newIndex : this.state.pageN,
            pages: arrayMove(this.state.pages, oldIndex, newIndex),
        });
    }

    async deletePage(i) {
        if (i === 0) return;
        if (!this.storyDoc) return;
        let doc = this.storyDoc.data();
        if (!doc.pages || doc.pages.length <= i) return;
        let delPage = doc.pages[i];
        let pages = doc.pages.filter(p => p !== doc.pages[i]);
        await this.story.update({pages: pages});
        await delPage.delete();
        this.setActivePage(i - 1);
    }

    render() {
        let editProps = {};
        if (!this.readOnly) {
            editProps = {
                toolsOpen: this.state.toolsOpen && !this.state.isDragging && !this.state.textToolsOpen,
                pagesOpen: this.state.pagesOpen && !this.state.textToolsOpen,
                textToolsOpen: this.state.textToolsOpen,
                onTextFocus: (pitem, focused) => this.onTextFocus(pitem, focused),
            }
        }
        return <div style={{width: '100%', height: '100%'}}>
            <StoryEditorView
                {...this.state}
                {...editProps}
                storyDoc={this.storyDoc}
                story={this.story}
                getCanvasRef={(ref) => this.canvasRef = ref}
                page={this.state.page}
                pageN={this.state.pageN}
                history={this.props.history}
                pages={this.state.pages}
                parentKey={this.state.uuidKey}
                width={this.props.width}
                height={this.props.height}
                bgImage={this._getCurrentBg()}
                readOnly={this.readOnly}
                preview={this.preview}
                actions={{
                    togglePages: () => this.state.toolsOpen ? null : this.setState({pagesOpen: !this.state.pagesOpen}),
                    toggleTools: () => this.state.pagesOpen ? null : this.setState({toolsOpen: !this.state.toolsOpen}),
                    editTitle: () => this.editTitle(),
                    openTools: () => (this.state.pagesOpen || this.state.toolsOpen === true || this.readOnly) ? null : this.setState({toolsOpen: true}),
                    closeTools: () => (this.state.toolsOpen === false || this.readOnly) ? null : this.setState({toolsOpen: false}),
                    closeAllPanes: () => ((this.state.toolsOpen === false && this.state.pagesOpen === false) || this.readOnly) ? null : this.setState({
                        toolsOpen: false,
                        pagesOpen: false
                    }),
                    finish: () => this.finish(),
                    addPage: this.readOnly ? null : () => this.addPage(),
                    setPage: (i) => this.setActivePage(i),
                    deletePage: this.readOnly ? null : (i) => this.deletePage(i),
                    reorderPages: this.readOnly ? null : (o, n) => this.reorderPages(o, n),
                    next: () => this.setActivePage(this.state.pageN + 1),
                    back: () => this.setActivePage(this.state.pageN - 1),
                }}
                events={{
                    paneMouseLeave: () => null,
                    onDragStart: () => {
                        this.setState({isDragging: true});
                    },
                    onDragEnd: () => {
                        this.setState({isDragging: false});
                    }
                }}
                toolsEventHandlers={{
                    background: (i) => this.setBackground(i),
                    textSize: (s) => this.onTextSizeChange(s),
                    textColor: (c) => this.onTextColorChange(c),
                    onDone: (c) => this.onTextDone(c)
                }}
                textToolsStyles={this.state.textToolsStyles}
            />
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    width: '2.8vw'
                }}/>
            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    left: 0,
                    height: '5vh'
                }}/>
        </div>
    }

    componentWillUnmount() {
        this.subscriptions.forEach(u => u());
    }

    hidePanes() {
        this.setState({
            toolsOpen: false,
            pagesOpen: false,
        });
    }

    onTextFocus(pitem, focused) {
        this.setState({
            textToolsOpen: focused,
            textPItem: pitem
        });
    }

    onTextDone(c) {
        this.onTextFocus(this.state.textPItem, false);
        this.canvasRef.current.click();
    }

    onTextColorChange(c) {
        let pitem = this.state.textPItem;
        let styles = {...pitem.textOverlay.styles};
        styles.color = c;
        pitem.textOverlay.styles = styles;
        this.setState(
            {
                textPItem: pitem
            }
        );
    }

    onTextSizeChange(s) {
        let pitem = this.state.textPItem;
        let styles = {...pitem.textOverlay.styles};
        styles.fontSize = s;
        pitem.textOverlay.styles = styles;
        this.setState(
            {
                textPItem: pitem
            }
        );
    }

    async setBackground(i) {
        this.setState({
            background: backgrounds[i],
        });
        if (this.state.pageN === 0) {
            // cover page
            this.story.update({background: i});
        }
        await this.state.page.update({background: i});
    }

    static readOnly(story) {
        return auth.currentUser.uid !== story.owner || window.location.href.includes(Routes.storyViewer);
    }
}

export default StoryEditor;
